import { EventEmitter, OnInit, ChangeDetectorRef, OnDestroy, ElementRef, OnChanges, SimpleChanges, Renderer2, } from '@angular/core';
import * as _ from 'lodash';
var TooltipComponent = /** @class */ (function () {
    function TooltipComponent(changeDetector, rtlService, renderer) {
        var _this = this;
        this.changeDetector = changeDetector;
        this.rtlService = rtlService;
        this.renderer = renderer;
        this.isReady = true;
        this.delay = 400;
        this.openOnClick = false;
        this.openOnClickWithoutStopPropagation = false;
        this.disposable = true;
        this.contentPadding = 5;
        this.tooltipPadding = true;
        this.alignCenter = true;
        this.disableClickOut = false;
        this.closeOnClick = false;
        this.close = new EventEmitter();
        this.open = new EventEmitter();
        this.dispose = new EventEmitter();
        this.ARROW_WIDTH = 8;
        this.right = 'right';
        this.left = 'left';
        this.onAnchorMouseEnter = function (event) {
            _this.isMouseLeave = false;
            setTimeout(function () {
                if (!_this.isMouseLeave) {
                    _this.isTooltipOpen = true;
                    _this.changeDetector.markForCheck();
                }
            }, _this.delay);
        };
        this.onAnchorCloseClick = function (event) {
            _this.onClose(event);
            _this.changeDetector.markForCheck();
        };
        this.toggleToolTip = function (event) {
            _this.isTooltipOpen = !_this.isTooltipOpen;
            _this.changeDetector.markForCheck();
            if (!_this.openOnClickWithoutStopPropagation) {
                event.stopPropagation();
            }
        };
        this.onAnchorMouseLeave = function (event) {
            setTimeout(function () {
                _this.isMouseLeave = true;
                if (!_this.keepOpenWhenMouseIn || !_this.isMouseInPopup) {
                    _this.onClose(event);
                }
                _this.changeDetector.markForCheck();
            }, 50);
        };
    }
    Object.defineProperty(TooltipComponent.prototype, "overlay", {
        get: function () {
            return !this.disposable;
        },
        enumerable: true,
        configurable: true
    });
    TooltipComponent.prototype.onHostClick = function ($event) {
        if (!this.disposable && $event.target.tagName.toLowerCase() === 'app-tooltip') {
            $event.stopPropagation();
            this.dispose.emit();
        }
    };
    TooltipComponent.prototype.ngOnInit = function () {
        this.rtl = this.rtlService.isRtl();
        if (this.rtl) {
            this.right = 'left';
            this.left = 'right';
        }
        this.tooltipPaddingPx = this.tooltipPadding ? 5 : 0;
        this.collision = { vertical: 'fit', horizontal: 'fit' };
        this.setPopupAndAnchorAlignByDirection(this.direction);
        this.setArrowClassByDirection(this.direction);
        if (this.anchor && !this.forceOpen) {
            this.addAnchorEvents();
        }
        else {
            this.isTooltipOpen = true;
        }
        this.isFirstOpen = true;
        this.checkedPosition = false;
        this.tooltipID = 'tooltip' + _.uniqueId();
    };
    TooltipComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.isReady && !changes.isReady.isFirstChange() && this.isTooltipOpen &&
            changes.isReady.currentValue && !changes.isReady.previousValue) {
            setTimeout(function () {
                if (_this.haveCollision()) {
                    _this.flip();
                }
                _this.setArrowPosition();
                _this.checkedPosition = true;
                _this.changeDetector.markForCheck();
            }, 0);
        }
    };
    TooltipComponent.prototype.ngOnDestroy = function () {
        this.removeAnchorEvents();
    };
    TooltipComponent.prototype.closeTooltip = function () {
        this.isTooltipOpen = false;
        this.changeDetector.markForCheck();
    };
    TooltipComponent.prototype.openTooltip = function () {
        this.isTooltipOpen = true;
        this.changeDetector.markForCheck();
    };
    TooltipComponent.prototype.setArrowClassByDirection = function (direction) {
        switch (direction) {
            case 'top':
                this.arrowClass = 'bottom-arrow';
                break;
            case 'right':
                this.arrowClass = 'left-arrow';
                break;
            case 'left':
                this.arrowClass = 'right-arrow';
                break;
            default:
                this.arrowClass = 'top-arrow';
        }
    };
    TooltipComponent.prototype.setPopupAndAnchorAlignByDirection = function (direction) {
        var horizontalAlign = this.alignCenter ? 'center' : this.left;
        var verticalAlign = this.alignCenter ? 'center' : 'bottom';
        switch (direction) {
            case 'top':
                this.anchorAlign = { horizontal: horizontalAlign, vertical: 'top' };
                this.popupAlign = { horizontal: horizontalAlign, vertical: 'bottom' };
                break;
            case 'right':
                this.anchorAlign = { horizontal: this.right, vertical: verticalAlign };
                this.popupAlign = { horizontal: this.left, vertical: verticalAlign };
                break;
            case 'left':
                this.anchorAlign = { horizontal: this.left, vertical: verticalAlign };
                this.popupAlign = { horizontal: this.right, vertical: verticalAlign };
                break;
            default:
                this.anchorAlign = { horizontal: horizontalAlign, vertical: 'bottom' };
                this.popupAlign = { horizontal: horizontalAlign, vertical: 'top' };
        }
    };
    TooltipComponent.prototype.setArrowPosition = function (recalc) {
        if (this.popupElement) {
            var anchorCenter = void 0;
            if (this.anchor) {
                //Calculate the center of the anchor with the left padding and without the right padding
                var anchorRects = this.anchor.getClientRects()[0];
                var leftBeforeOffset = void 0;
                if (this.alignCenter) {
                    // it is not likely that someone would require the right/left padding adjustments
                    // for a centeralized tooltip. we would prefer to avoid doing unnecessary computed style checks
                    // even though there is a client-rects evalaution anyway
                    leftBeforeOffset = anchorRects.left + anchorRects.width / 2;
                }
                else {
                    var compusterStyle = window.getComputedStyle(this.anchor, null);
                    var paddingRight = compusterStyle.getPropertyValue('padding-right');
                    var paddingLeft = compusterStyle.getPropertyValue('padding-left');
                    leftBeforeOffset = anchorRects.left + anchorRects.width / 2 + this.pixelToNumber(paddingLeft) / 2 - this.pixelToNumber(paddingRight);
                }
                anchorCenter = {
                    // keep using the left even for rtl since the right does not provide the absolution correct location
                    left: leftBeforeOffset + (this.offset && this.offset.left ? this.offset.left : 0),
                    top: anchorRects.top + (anchorRects.height / 2) + (this.offset && this.offset.top ? this.offset.top : 0)
                };
            }
            else {
                anchorCenter = this.offset;
            }
            var positionDirection = void 0;
            var positionPixelsBefore = void 0;
            var positionPixelsAfter = void 0;
            // change the minimum edge to 0
            var edge = 0;
            var popupRects = this.popupElement.nativeElement.getClientRects()[0];
            if (this.arrowClass === "top-arrow" || this.arrowClass === "bottom-arrow") {
                positionDirection = "left"; //always use left regardless of rtl
                var popupWidth = popupRects.width - this.tooltipPaddingPx * 2;
                positionPixelsBefore = Math.max(Math.min(Math.ceil(anchorCenter.left - popupRects.left - this.tooltipPaddingPx - this.ARROW_WIDTH / 2 - 3), popupWidth - edge), edge);
                positionPixelsBefore = positionPixelsBefore;
                positionPixelsAfter = positionPixelsBefore + 1;
            }
            else {
                positionDirection = "top";
                var popupHeight = popupRects.height - this.tooltipPaddingPx * 2;
                positionPixelsBefore = Math.max(Math.min(Math.ceil(anchorCenter.top - popupRects.top - this.tooltipPaddingPx), popupHeight - edge), edge);
                positionPixelsAfter = positionPixelsBefore;
            }
            if (recalc) {
                (this.popupElement.nativeElement.parentElement).find("style").remove();
            }
            var styleElement = this.renderer.createElement('style');
            styleElement.textContent =
                '.' + this.arrowClass + '.' + this.tooltipID + ':before{' + positionDirection + ':' + positionPixelsBefore + 'px !important;} ' +
                    '.' + this.arrowClass + '.' + this.tooltipID + ':after{' + positionDirection + ':' + positionPixelsAfter + 'px !important;}';
            this.popupElement.nativeElement.parentElement.append(styleElement);
        }
    };
    TooltipComponent.prototype.addAnchorEvents = function () {
        if (this.anchor && this.anchor.addEventListener) {
            if (this.openOnClick) {
                this.anchor.addEventListener('click', this.toggleToolTip);
            }
            else {
                this.anchor.addEventListener('mouseenter', this.onAnchorMouseEnter);
                this.anchor.addEventListener('mouseleave', this.onAnchorMouseLeave);
                if (this.closeOnClick) {
                    this.anchor.addEventListener('click', this.onAnchorCloseClick);
                }
            }
        }
    };
    TooltipComponent.prototype.removeAnchorEvents = function () {
        if (this.anchor && this.anchor.removeEventListener) {
            if (this.openOnClick) {
                this.anchor.removeEventListener('click', this.toggleToolTip);
            }
            else {
                this.anchor.removeEventListener('mouseenter', this.onAnchorMouseEnter);
                this.anchor.removeEventListener('mouseleave', this.onAnchorMouseLeave);
                if (this.closeOnClick) {
                    this.anchor.removeEventListener('click', this.onAnchorCloseClick);
                }
            }
        }
    };
    TooltipComponent.prototype.onPopupMouseEnter = function () {
        this.isMouseInPopup = true;
    };
    TooltipComponent.prototype.onPopupMouseLeave = function (event) {
        this.isMouseInPopup = false;
        if (this.isMouseLeave && this.isTooltipOpen) {
            this.onClose(event);
        }
    };
    TooltipComponent.prototype.onClose = function (event) {
        this.isTooltipOpen = false;
        this.close.emit(event);
    };
    TooltipComponent.prototype.onOpen = function (event) {
        var _this = this;
        if (this.isFirstOpen) {
            this.isFirstOpen = false;
            // depending on the DOM the tooltip needs to set itself on the correct location so we will wait..
            setTimeout(function () {
                if (_this.isReady) {
                    _this.checkedPosition = true;
                    if (_this.haveCollision()) {
                        _this.flip();
                    }
                    _this.setArrowPosition();
                    _this.changeDetector.markForCheck();
                }
            });
        }
        this.open.emit(event);
    };
    TooltipComponent.prototype.haveCollision = function () {
        // The collision set to be "fit" so if the popup on the edge I suppose that was a collision.
        var popupRects = this.popupElement.nativeElement.getClientRects()[0];
        switch (this.direction) {
            case 'top':
                return popupRects.top <= 0;
            case this.right:
                return Math.ceil(popupRects.left + popupRects.width) >= document.body.clientWidth;
            case this.left:
                return popupRects.left <= 0;
            default:
                return Math.ceil(popupRects.top + popupRects.height) >= document.body.clientHeight;
        }
    };
    TooltipComponent.prototype.flip = function () {
        var newDirection;
        switch (this.direction) {
            case 'top':
                newDirection = 'bottom';
                break;
            case 'right':
                newDirection = 'left';
                break;
            case 'left':
                newDirection = 'right';
                break;
            default:
                newDirection = 'top';
        }
        this.setPopupAndAnchorAlignByDirection(newDirection);
        this.setArrowClassByDirection(newDirection);
    };
    TooltipComponent.prototype.onClickOut = function (event) {
        if (this.openOnClick) {
            if (event.target === this.anchor) {
                return;
            }
            if (this.isTooltipOpen) {
                this.toggleToolTip(event);
            }
        }
    };
    TooltipComponent.prototype.pixelToNumber = function (valueWithPx) {
        return +(valueWithPx.substring(0, valueWithPx.indexOf("px")));
    };
    return TooltipComponent;
}());
export { TooltipComponent };
